import React from 'react';
import { Link } from 'react-router-dom';


const ContentCreator = () => {
  return (
    <div className="pricing" id="pricing">
      {/* <div className="dots dots-up"></div>
      <div className="dots dots-down"></div> */}
      <h2 className="main-title">Content Creation and Entrepenaria</h2>
      <div className="container">
        <div className="box popular">
          <div className="label">Content Creation and Entrepenaria</div>
          
          <h2>World Web Solutution</h2>  
          <ul style={{"text-align":"center"}}>
          <div className="world">
          <img src="imgs/Black and White Monochrome Tech Logo.png" alt="" />
        </div>
            <li>World Web Solutions is my humble endeavor in the real world, where I aim to teach, offer advice, and create content related to programming and technology, with a special focus on web development. It also represents a small company that I founded with the invaluable assistance of dedicated associates who share my passion for providing top-notch website development services. Our goal is to collaborate with clients not only in the USA and Algeria but also from around the globe.</li>
          </ul>
          <div className="social-content" >
                  <a href="https://www.facebook.com/WorldWebSoolutions" target='_blanck'>
                    <i className="fab fa-facebook-f" target='_blanck'></i>
                  </a>
                  <a href="https://twitter.com/WebSoolutions" target='_blanck'>
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="https://www.instagram.com/worldweb_solutions/" target='_blanck'>
                  <i class="fab fa-instagram"></i>
                  </a>
                  <a href="https://www.youtube.com/channel/UCOAfhjjWrgAWCil4XiZrOpg">
                    <i className="fab fa-youtube" target='_blanck'></i>
                  </a>
                  <a href="https://www.tiktok.com/@worldwebsolutions">
                    <i className="fab fa-tiktok" target='_blanck'></i>
                  </a>
                </div>
        
                {/* <video width="750" height="500" loop autoPlay>
                         <source src="imgs/world.mp4" type="video/mp4"/>
                </video> */}
              
        </div>
      </div>  <img style={{'width':'100%'}}src='imgs/banner.png'></img>
    </div>
  );
};

export default ContentCreator;
